<div class="modal-outer-wrapper mt-4 congratulations-outer">
    <div class="modal-inner-wrapper">
        <svg width="100" height="100" viewBox="0 0 121 121" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M60.5 120.5C93.6371 120.5 120.5 93.6371 120.5 60.5C120.5 27.3629 93.6371 0.5 60.5 0.5C27.3629 0.5 0.5 27.3629 0.5 60.5C0.5 93.6371 27.3629 120.5 60.5 120.5Z"
                fill="#1D4ED8" />
            <rect width="24" height="24.2017" transform="translate(50.5 48.8647)" fill="#1D4ED8" />
            <path
                d="M59.4998 65.1007L72.4989 52.8647L74.5 54.7468L59.4998 68.8647L50.5 60.3942L52.4996 58.5122L59.4998 65.1007Z"
                fill="white" />
        </svg>
        <h3 class="my-0">Congratulations!</h3>
        <p class="my-0">{{bodyText}}</p>
        <div class="flex flex-column gap-2 mb-4">
            <p-button label="OK" class="w-100 btn-continue" (onClick)="continue()"></p-button>
        </div>
    </div>
</div>